module.exports = "/_next/static/images/logo_white-5b84e10c73370de6f7d47372291ab082.png";